import { createRoot } from 'react-dom/client'
import { useRoute, useLocation } from 'wouter'
import './styles.css'
import { App } from './App'
import Particles from './Particles'

function Root() {
  const [, params] = useRoute('/item/:id')
  const [, setLocation] = useLocation()

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      {/* Particle background */}
      <div style={{ position: 'absolute', inset: 0, zIndex: 0 }}>
        <Particles
          particleColors={['#ffffff', '#ccccff', '#ffccff']}
          particleCount={250}
          particleSpread={8}
          speed={0.2}
          particleBaseSize={80}
          moveParticlesOnHover={true}
          alphaParticles={false}
        />
      </div>

      {/* Main App on top */}
      <div style={{ position: 'relative', zIndex: 1, width: '100%', height: '100%' }}>
        <App />
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
          {params && (
            <a
              style={{
                position: 'absolute',
                top: 40,
                left: 40,
                fontSize: '14px',
                background: 'rgba(255,255,255,0.7)',
                padding: '8px 15px',
                borderRadius: '4px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                transition: 'all 0.2s ease',
              }}
              href="#"
              onClick={(e) => {
                e.preventDefault()
                setLocation('/')
              }}
            >
              ← Back to gallery
            </a>
          )}
        </div>
      </div>
    </div>
  )
}

createRoot(document.getElementById('root')).render(<Root />)
